import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';
import { GlobalName } from '../utils/global-name';

@Injectable({
  providedIn: 'root'
})
export class StudentAyClassroomService {

  url=ConfigService.toApiUrl("sacs/");

  constructor(private http:HttpClient) { }

    getAll(classroomId?:any,ayId?:any){
    return this.http.get<any[]>(`${this.url}?classroom_id=${classroomId}&ayId=${ayId}`,ConfigService.addAction('list'));
  }
  getForValidation(classroomId:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("sacs-for-validation")}/${classroomId}`,ConfigService.addAction('list'));
  }
  
  getWithTemplate(classroomId?:any,ayId?:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("sacs-templates/")}${classroomId}/${ayId}`,ConfigService.addAction('list'));
  }
  
  getWithHealths(classroomId?:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("sacs-healths/")}${classroomId}`,ConfigService.addAction('list'));
  }
 
  getByState(state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("sacs-by-state")}/${state}`,ConfigService.addAction('list'));
  }

  store(ressource:any){
    return this.http.post<any>(`${this.url}`, ressource,
     ConfigService.addAction('add'));
  }

  getFollowUp(ressource:any){
    return this.http.post<any>(`${ConfigService.toApiUrl("sacs-follow-up")}`, ressource,
     ConfigService.addAction('list'));
  }

  update(id:any,ressource:any){
    //ressource['_method']='patch';
    ressource.append('_method','patch');

    return this.http.post<any>(`${this.url}${id}`, ressource,  ConfigService.addAction('edit'));
  }
  delete(id:any){
    return this.http.delete<any>(`${this.url}${id}`,
     ConfigService.addAction('delete'));
  }

  get(id:any){
    return this.http.get<any>(`${this.url}${id}`,
     ConfigService.addAction('show'));
  }

  setState(id:any,state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("sacs-set-state")}/${id}/state/${state}`,ConfigService.addAction('status'));
  }
}
